import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {CalendarTemplate} from '../../../../projects/api/src/template/template.model';
import {SemRestRequestService} from '../../../../projects/api/src/sem-rest-request/sem-rest-request.service';
import { SnackBarService } from '../snackbar-service';
import {ApiList} from '../../API/api-list.enum';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-calendar-template-panel-edit',
    templateUrl: './calendar-template-panel-edit.component.html',
    styleUrls: ['./calendar-template-panel-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CalendarTemplatePanelEditComponent implements OnInit {
  @Input() referenceData: any;
  @Input() editableData: CalendarTemplate;
  @Input() saveComplete;
  @Input() create;

  constructor(private request: SemRestRequestService,
              private translate: TranslateService,
              private snackBar: MatSnackBar,
              private snackBarService: SnackBarService) {
  }

  public names = [];
  public ids = [];
  public target = 'holiday';

  ngOnInit() {
    if (!this.editableData) {
      this.editableData = {
        id: 0,
        name: '',
        description: '',
      };
    }
      this.ids.push(this.editableData.id);
      this.names.push(this.editableData);

  }
  /**
   * Сохраняет шаблон календаря
   */
  public save(message: any) {
    this.request.baseUrlAppend(ApiList.Db, ApiList.Calendar);
      this.saveComplete();
      this.snackBarService.add(this.translate.instant('Item successfully saved'),
        null,
        {duration: 3000, panelClass: ['c-mat-snack-bar_container__bottom-right', 'c-mat-snack-bar__success']});
  }

  /**
   * Выполняет валидацию формы
   */
  public validate() {
    return this.editableData.name.replace(/\s/g, '').length > 0;
  }

}
